<template lang="pug">
el-select(v-model="model")
  el-option(
    v-for="option in options",
    :key="option.value",
    :value="option.value",
    :label="option.label"
  )
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
  getConfiguredLanguages,
  getLanguageLabel,
} from "@shared/util/languages";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  modelValue: string;
}>();

const emit = defineEmits(["update:modelValue"]);
const { t } = useI18n();

const model = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emit("update:modelValue", val);
  },
});

const options = computed(() =>
  getConfiguredLanguages().map((value) => ({
    label: t(getLanguageLabel(value)),
    value,
  })),
);
</script>
